'use client'

import classNames from 'clsx'
import { ComponentPropsWithoutRef, forwardRef, ReactNode } from 'react'

import S from '../Table.module.scss'

export interface TableLoadMoreProps extends ComponentPropsWithoutRef<'div'> {
  show?: boolean
  loading?: boolean
  onLoadMore?: () => void
  children?: ReactNode
}

export const TableLoadMore = forwardRef<HTMLDivElement, TableLoadMoreProps>(
  ({ className, children, show = true, ...props }, ref) => {
    if (!show) {
      return null
    }

    return (
      <div {...props} ref={ref} className={classNames(S.loadMore, className)}>
        {children}
      </div>
    )
  }
)

TableLoadMore.displayName = 'Table.LoadMore'

export interface TableEmptyProps extends ComponentPropsWithoutRef<'div'> {}

export const TableEmpty = forwardRef<HTMLDivElement, TableEmptyProps>(
  ({ className, children, ...props }, ref) => {
    return (
      <div {...props} ref={ref} className={classNames(S.empty, className)}>
        {children}
      </div>
    )
  }
)

TableEmpty.displayName = 'Table.Empty'

export interface TableLoadingProps extends ComponentPropsWithoutRef<'div'> {}

export const TableLoading = forwardRef<HTMLDivElement, TableLoadingProps>(
  ({ className, children, ...props }, ref) => {
    return (
      <div {...props} ref={ref} className={classNames(S.loading, className)}>
        {children}
      </div>
    )
  }
)

TableLoading.displayName = 'Table.Loading'
